import { subDays } from 'date-fns';
export var mockData = [
    {
        id: 1,
        type: 'PREMIUM',
        maxUsers: 110,
        docAlertsPerUser: 100,
        price: 299,
        pricePerUser: 2.99,
        isAiInsights: true,
        isTimeline: true,
        createdAt: subDays(new Date(), 10).toISOString(),
        updatedAt: subDays(new Date(), 10).toISOString()
    }
];
